// extracted by mini-css-extract-plugin
export default {"dialog":"PlainDialog_dialog__JJ-1x","screen":"PlainDialog_screen__zkKZd","content":"PlainDialog_content__34I1b"};